import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import InformationModal from '../components/InformationModal';

const Login = ({ onToggleView, regFetch }) => {
  const [formData, setFormData] = useState({
    username: '',
    password: '',
    lenderId: ''
  });
  const [errors, setErrors] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [lenders, setLenders] = useState([]);
  const [loadingLenders, setLoadingLenders] = useState(true);
  const [lendersError, setLendersError] = useState(null);

  const nav= useNavigate();

  const fetchLenders = async () => {
      setLoadingLenders(true);
      try {
        const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/api/auth/getMasterLenderNames`);
        if (!response.ok) {
          throw new Error('Failed to fetch lenders');
        }
        const data = await response.json();
        setLenders(Object.entries(data).map(([id, name]) => ({ id: parseInt(id), name })));
      } catch (error) {
        console.error('Error fetching lenders:', error);
        setLendersError(error.message);
      } finally {
        setLoadingLenders(false);
      }
    };

  // Fetch lenders when the component mounts
  useEffect(() => {
    fetchLenders();
  }, []);

  useEffect(() => {
    fetchLenders();
  }, [regFetch]);

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const validateField = (name, value) => {
    let error = '';
    switch (name) {
      case 'username':
        if (!value.trim()) error = 'Username is required';
        break;
      case 'password':
        if (!value.trim()) error = 'Password is required';
        else if (value.length < 6) error = 'Password must be at least 6 characters';
        break;
      case 'lenderId':
        if (!value) error = 'Lender is required';
        break;
      default:
        break;
    }
    return error;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    const error = validateField(name, value);
    setErrors(prev => ({ ...prev, [name]: error }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let isValid = true;
    const newErrors = {};
    Object.keys(formData).forEach(field => {
      const error = validateField(field, formData[field]);
      if (error) {
        newErrors[field] = error;
        isValid = false;
      }
    });
    setErrors(newErrors);
    if (isValid) {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/api/auth/loginMasterLender`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
          credentials: "include"
        });
        const data = await response.json();
        if (!response.ok) {
          throw new Error(data.error || 'Login failed');
        }
        // Show success modal
        nav("/ZoneRegionManager")
        console.log('Login successful:', data);
        // Handle successful login, e.g., redirect to another page
      } catch (error) {
        console.error('Error during login:', error);
        // Show error modal
        setModalMessage(error.message || 'Error during login');
        setIsModalOpen(true);
      }
    }
  };

  return (
    <div className="col-md-6" style={{ padding: '20px', display:"flex", justifyContent:"center", alignItems:"center" }}>
      <div className="card mt-5" style={{ border: 'none', boxShadow: '0px 0px 10px rgba(0,0,0,0.1)', width:"350px", height:"70vh" }}>
        <div className="card-body">
          <h2 className="text-center mb-4" style={{ color: '#ee373b' }}>Login</h2>
          <form className="d-flex flex-column justify-content-between w-100" style={{height:"80%"}} onSubmit={handleSubmit}>
            <div className='d-flex flex-column justify-content-center w-100 h-100'>
              <div className="form-group">
                <label>Lender</label>
                {loadingLenders ? (
                  <div>Loading lenders...</div>
                ) : lendersError ? (
                  <div className="text-danger bg-white">Error loading lenders: {lendersError}</div>
                ) : (
                  <select
                    className={`form-control ${errors.lenderId ? 'is-invalid' : ''}`}
                    name="lenderId"
                    value={formData.lenderId}
                    onChange={handleChange}
                    disabled={loadingLenders}
                  >
                    <option value="">Select a lender</option>
                    {lenders.map(lender => (
                      <option key={lender.id} value={lender.id}>{lender.name}</option>
                    ))}
                  </select>
                )}
                {errors.lenderId && <div className="invalid-feedback">{errors.lenderId}</div>}
              </div>
              <div className="form-group">
                <label>Username</label>
                <input type="text" className={`form-control ${errors.username ? 'is-invalid' : ''}`} name="username" value={formData.username} onChange={handleChange} />
                {errors.username && <div className="invalid-feedback">{errors.username}</div>}
              </div>
              <div className="form-group">
                <label>Password</label>
                <input type="password" className={`form-control ${errors.password ? 'is-invalid' : ''}`} name="password" value={formData.password} onChange={handleChange} />
                {errors.password && <div className="invalid-feedback">{errors.password}</div>}
              </div>
            </div>
            <div className="d-flex justify-content-center mt-4">
              <button type="submit" className="btn" style={{ backgroundColor: '#ee373b', color: 'white' }} disabled={loadingLenders}>
                Login
              </button>
            </div>
          </form>
        </div>
      </div>
      <InformationModal isOpen={isModalOpen} onClose={handleCloseModal} message={modalMessage} />
    </div>
  );
};

// const MultiStepRegistrationForm = ({fetchLenders}) => {
//   const [currentStep, setCurrentStep] = useState(1);
//   const [formData, setFormData] = useState({
//     lenderName: '',
//     email: '',
//     phoneNumber: '',
//     gstNumber: '',
//     panNumber: '',
//     username: '',
//     password: '',
//     confirmPassword: '',
//     userType: 'Lender'
//   });
//   const [errors, setErrors] = useState({});
//   const [touched, setTouched] = useState({});
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [modalMessage, setModalMessage] = useState('');

//   const handleCloseModal = () => {
//     setIsModalOpen(false);
//   };

//   const validateGST = (gst) => {
//     if (!gst || gst.trim() === "") {
//       return "GST Number is required";
//     }
//     if (
//       !/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(gst)
//     ) {
//       return "Please enter a valid GST number";
//     }
//     return "";
//   };

//   const validatePAN = (pan) => {
//     if (!pan || pan.trim() === "") {
//       return "PAN Number is required";
//     }
//     if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(pan)) {
//       return "Please enter a valid PAN number";
//     }
//     return "";
//   };

//   const validateField = (name, value) => {
//     let error = '';
//     switch (name) {
//       case 'lenderName':
//         if (!value.trim()) error = 'Lender Name is required';
//         break;
//       case 'email':
//         if (!value.trim()) error = 'Email is required';
//         else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) error = 'Invalid email format';
//         break;
//       case 'phoneNumber':
//         if (!value.trim()) error = 'Phone Number is required';
//         else if (!/^\d{10,}$/.test(value)) error = 'Invalid phone number';
//         break;
//       case 'userType':
//         if (!value) error = 'User type is required';
//         break;
//       case 'username':
//         if (!value.trim()) error = 'Username is required';
//         break;
//       case 'password':
//         if (!value.trim()) error = 'Password is required';
//         else if (value.length < 6) error = 'Password must be at least 6 characters';
//         break;
//       case 'confirmPassword':
//         if (!value.trim()) error = 'Confirm Password is required';
//         else if (value !== formData.password) error = 'Passwords do not match';
//         break;
//       case 'gstNumber':
//         error = validateGST(value);
//         break;
//       case 'panNumber':
//         error = validatePAN(value);
//         break;
//       default:
//         break;
//     }
//     return error;
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({ ...prev, [name]: value }));
//     setTouched(prev => ({ ...prev, [name]: true }));
//     const error = validateField(name, value);
//     setErrors(prev => ({ ...prev, [name]: error }));
//     if (name === 'password' || name === 'confirmPassword') {
//       const otherField = name === 'password' ? 'confirmPassword' : 'password';
//       if (touched[otherField]) {
//         const otherError = validateField(otherField, formData[otherField]);
//         setErrors(prev => ({ ...prev, [otherField]: otherError }));
//       }
//     }
//   };

//   const handleBlur = (e) => {
//     const { name, value } = e.target;
//     setTouched(prev => ({ ...prev, [name]: true }));
//     const error = validateField(name, value);
//     setErrors(prev => ({ ...prev, [name]: error }));
//     if (name === 'password' || name === 'confirmPassword') {
//       const otherField = name === 'password' ? 'confirmPassword' : 'password';
//       if (touched[otherField]) {
//         const otherError = validateField(otherField, formData[otherField]);
//         setErrors(prev => ({ ...prev, [otherField]: otherError }));
//       }
//     }
//   };

//   const validateStep = (step) => {
//     let isValid = true;
//     const newErrors = { ...errors };
//     if (step === 1) {
//       const fields = ['lenderName', 'email', 'phoneNumber', 'userType'];
//       fields.forEach(field => {
//         const error = validateField(field, formData[field]);
//         if (error) {
//           newErrors[field] = error;
//           isValid = false;
//         }
//       });
//     } else if (step === 2) {
//       const fields = ['username', 'password', 'confirmPassword'];
//       fields.forEach(field => {
//         const error = validateField(field, formData[field]);
//         if (error) {
//           newErrors[field] = error;
//           isValid = false;
//         }
//       });
//     }
//     setErrors(newErrors);
//     return isValid;
//   };

//   const handleNext = () => {
//     if (validateStep(currentStep)) {
//       setCurrentStep(prev => prev + 1);
//     }
//   };

//   const handlePrevious = () => {
//     setCurrentStep(prev => prev - 1);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (validateStep(currentStep)) {
//       try {
//         const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/api/auth/registerMasterLender`, {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify({
//             lenderName: formData.lenderName,
//             email: formData.email,
//             phoneNumber: formData.phoneNumber,
//             gstNumber: formData.gstNumber,
//             panNumber: formData.panNumber,
//             username: formData.username,
//             password: formData.password,
//             userType: formData.userType
//           }),
//         });
//         const data = await response.text();
//         if (!response.ok) {
//           throw new Error(data.error || 'Registration failed');
//         }
//         setModalMessage('Registration successful!');
//         setIsModalOpen(true);
//         console.log('Registration successful:', data);
//       } catch (error) {
//         console.error('Error during registration:', error);
//         setModalMessage(error.message || 'Error during registration');
//         setIsModalOpen(true);
//       }
//       finally{
//         fetchLenders();
//         setFormData({
//           lenderName: '',
//           email: '',
//           phoneNumber: '',
//           username: '',
//           password: '',
//           confirmPassword: '',
//           userType: 'Lender'
//         })
//       }
//     }
//   };

//   return (
//     <div
//       className="col-md-6"
//       style={{
//         padding: "20px",
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//       }}
//     >
//       <div
//         className="card mt-5"
//         style={{
//           border: "none",
//           boxShadow: "0px 0px 10px rgba(0,0,0,0.1)",
//           maxWidth: "33vw",
//           height: "70vh",
//         }}
//       >
//         <div className="card-body">
//           <h2 className="text-center mb-4" style={{ color: "#ee373b" }}>
//             Registration
//           </h2>
//           <form
//             className="d-flex flex-column justify-content-between w-100"
//             style={{ height: "80%" }}
//             onSubmit={handleSubmit}
//           >
//             <div className="w-100 h-100">
//               {currentStep === 1 && (
//                 <>
//                   <div className="form-group">
//                     <label>Lender Name</label>
//                     <input
//                       type="text"
//                       className={`form-control ${
//                         touched.lenderName && errors.lenderName
//                           ? "is-invalid"
//                           : ""
//                       }`}
//                       name="lenderName"
//                       value={formData.lenderName}
//                       onChange={handleChange}
//                       onBlur={handleBlur}
//                     />
//                     {touched.lenderName && errors.lenderName && (
//                       <div className="invalid-feedback">
//                         {errors.lenderName}
//                       </div>
//                     )}
//                   </div>
//                   <div className="form-group">
//                     <label>Email</label>
//                     <input
//                       type="email"
//                       className={`form-control ${
//                         touched.email && errors.email ? "is-invalid" : ""
//                       }`}
//                       name="email"
//                       value={formData.email}
//                       onChange={handleChange}
//                       onBlur={handleBlur}
//                     />
//                     {touched.email && errors.email && (
//                       <div className="invalid-feedback">{errors.email}</div>
//                     )}
//                   </div>
//                   <div className="form-group">
//                     <label>Phone Number</label>
//                     <input
//                       type="text"
//                       className={`form-control ${
//                         touched.phoneNumber && errors.phoneNumber
//                           ? "is-invalid"
//                           : ""
//                       }`}
//                       name="phoneNumber"
//                       value={formData.phoneNumber}
//                       onChange={handleChange}
//                       onBlur={handleBlur}
//                     />
//                     {touched.phoneNumber && errors.phoneNumber && (
//                       <div className="invalid-feedback">
//                         {errors.phoneNumber}
//                       </div>
//                     )}
//                   </div>
//                   <div className="form-group">
//                     <label>GST Number</label>
//                     <input
//                       type="text"
//                       className={`form-control ${touched.gstNumber && errors.gstNumber ? "is-invalid" : ""}`}
//                       name="gstNumber"
//                       value={formData.gstNumber}
//                       onChange={handleChange}
//                       onBlur={handleBlur}
//                     />
//                     {touched.gstNumber && errors.gstNumber && (
//                       <div className="invalid-feedback">{errors.gstNumber}</div>
//                     )}
//                   </div>

//                   <div className="form-group">
//                     <label>PAN Number</label>
//                     <input
//                       type="text"
//                       className={`form-control ${touched.panNumber && errors.panNumber ? "is-invalid" : ""}`}
//                       name="panNumber"
//                       value={formData.panNumber}
//                       onChange={handleChange}
//                       onBlur={handleBlur}
//                     />
//                     {touched.panNumber && errors.panNumber && (
//                       <div className="invalid-feedback">{errors.panNumber}</div>
//                     )}
//                   </div>
//                   <div className="form-group">
//                     <label
//                       style={{
//                         fontWeight: "bold",
//                         display: "block",
//                         marginBottom: "0.5rem",
//                       }}
//                     >
//                       Share Contact Details
//                     </label>
//                     <div
//                       style={{
//                         display: "flex",
//                         alignItems: "center",
//                         gap: "1rem",
//                       }}
//                     >
//                       <label
//                         style={{
//                           position: "relative",
//                           display: "inline-block",
//                           width: "50px",
//                           height: "24px",
//                         }}
//                       >
//                         <input
//                           type="checkbox"
//                           checked={formData.userType === "Lender"}
//                           onChange={(e) =>
//                             setFormData((prev) => ({
//                               ...prev,
//                               userType: e.target.checked
//                                 ? "Lender"
//                                 : "Private Lender",
//                             }))
//                           }
//                           style={{ opacity: 0, width: 0, height: 0 }}
//                         />
//                         <span
//                           style={{
//                             position: "absolute",
//                             cursor: "pointer",
//                             top: 0,
//                             left: 0,
//                             right: 0,
//                             bottom: 0,
//                             backgroundColor:
//                               formData.userType === "Lender"
//                                 ? "#ee373b"
//                                 : "#ccc",
//                             transition: "0.2s",
//                             borderRadius: "24px",
//                           }}
//                         ></span>
//                         <span
//                           style={{
//                             position: "absolute",
//                             content: '""',
//                             height: "18px",
//                             width: "18px",
//                             left:
//                               formData.userType === "Lender" ? "26px" : "4px",
//                             bottom: "3px",
//                             backgroundColor: "white",
//                             transition: "0.2s",
//                             borderRadius: "50%",
//                           }}
//                         ></span>
//                       </label>
//                       <span style={{ fontSize: "0.9rem" }}>
//                         {formData.userType === "Lender"
//                           ? "Yes"
//                           : "No"}
//                       </span>
//                     </div>
//                   </div>
//                 </>
//               )}
//               {currentStep === 2 && (
//                 <>
//                   <div className="form-group">
//                     <label>Username</label>
//                     <input
//                       type="text"
//                       className={`form-control ${
//                         touched.username && errors.username ? "is-invalid" : ""
//                       }`}
//                       name="username"
//                       value={formData.username}
//                       onChange={handleChange}
//                       onBlur={handleBlur}
//                     />
//                     {touched.username && errors.username && (
//                       <div className="invalid-feedback">{errors.username}</div>
//                     )}
//                   </div>
//                   <div className="form-group">
//                     <label>Password</label>
//                     <input
//                       type="password"
//                       className={`form-control ${
//                         touched.password && errors.password ? "is-invalid" : ""
//                       }`}
//                       name="password"
//                       value={formData.password}
//                       onChange={handleChange}
//                       onBlur={handleBlur}
//                     />
//                     {touched.password && errors.password && (
//                       <div className="invalid-feedback">{errors.password}</div>
//                     )}
//                   </div>
//                   <div className="form-group">
//                     <label>Confirm Password</label>
//                     <input
//                       type="password"
//                       className={`form-control ${
//                         touched.confirmPassword && errors.confirmPassword
//                           ? "is-invalid"
//                           : ""
//                       }`}
//                       name="confirmPassword"
//                       value={formData.confirmPassword}
//                       onChange={handleChange}
//                       onBlur={handleBlur}
//                     />
//                     {touched.confirmPassword && errors.confirmPassword && (
//                       <div className="invalid-feedback">
//                         {errors.confirmPassword}
//                       </div>
//                     )}
//                   </div>
//                 </>
//               )}
//             </div>
//             <div className="d-flex justify-content-between mt-4 w-100">
//               {currentStep > 1 && (
//                 <button
//                   type="button"
//                   className="btn"
//                   style={{ backgroundColor: "#ee373b", color: "white" }}
//                   onClick={handlePrevious}
//                 >
//                   Previous
//                 </button>
//               )}
//               {currentStep < 2 ? (
//                 <button
//                   type="button"
//                   className="btn ml-auto"
//                   style={{ backgroundColor: "#ee373b", color: "white" }}
//                   onClick={handleNext}
//                 >
//                   Next
//                 </button>
//               ) : (
//                 <button
//                   type="submit"
//                   className="btn ml-auto"
//                   style={{ backgroundColor: "#ee373b", color: "white" }}
//                 >
//                   Submit
//                 </button>
//               )}
//             </div>
//           </form>
//         </div>
//       </div>
//       <InformationModal
//         isOpen={isModalOpen}
//         onClose={handleCloseModal}
//         message={modalMessage}
//       />
//     </div>
//   );
// };

const MultiStepRegistrationForm = ({ setRegFetch }) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [entityType, setEntityType] = useState('DSA'); // DSA or Loan Processing Lender
  const [formData, setFormData] = useState({
    lenderName: '',
    email: '',
    phoneNumber: '',
    gstNumber: '',
    panNumber: '',
    username: '',
    password: '',
    confirmPassword: '',
    userType: 'DSA'
  });
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState('');

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const validateGST = (gst) => {
    if (!gst || gst.trim() === "") {
      return "GST Number is required";
    }
    if (!/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(gst)) {
      return "Please enter a valid GST number";
    }
    return "";
  };

  const validatePAN = (pan) => {
    if (!pan || pan.trim() === "") {
      return "PAN Number is required";
    }
    if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(pan)) {
      return "Please enter a valid PAN number";
    }
    return "";
  };

  const validateField = (name, value) => {
    let error = '';
    switch (name) {
      case 'lenderName':
        if (!value.trim()) error = 'Lender Name is required';
        break;
      case 'email':
        if (!value.trim()) error = 'Email is required';
        else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) error = 'Invalid email format';
        break;
      case 'phoneNumber':
        if (!value.trim()) error = 'Phone Number is required';
        else if (!/^\d{10,}$/.test(value)) error = 'Invalid phone number';
        break;
      case 'userType':
        if (!value) error = 'User type is required';
        break;
      case 'username':
        if (!value.trim()) error = 'Username is required';
        break;
      case 'password':
        if (!value.trim()) error = 'Password is required';
        else if (value.length < 6) error = 'Password must be at least 6 characters';
        break;
      case 'confirmPassword':
        if (!value.trim()) error = 'Confirm Password is required';
        else if (value !== formData.password) error = 'Passwords do not match';
        break;
      case 'gstNumber':
        error = validateGST(value);
        break;
      case 'panNumber':
        error = validatePAN(value);
        break;
      default:
        break;
    }
    return error;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    setTouched(prev => ({ ...prev, [name]: true }));
    const error = validateField(name, value);
    setErrors(prev => ({ ...prev, [name]: error }));
    if (name === 'password' || name === 'confirmPassword') {
      const otherField = name === 'password' ? 'confirmPassword' : 'password';
      if (touched[otherField]) {
        const otherError = validateField(otherField, formData[otherField]);
        setErrors(prev => ({ ...prev, [otherField]: otherError }));
      }
    }
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    setTouched(prev => ({ ...prev, [name]: true }));
    const error = validateField(name, value);
    setErrors(prev => ({ ...prev, [name]: error }));
    if (name === 'password' || name === 'confirmPassword') {
      const otherField = name === 'password' ? 'confirmPassword' : 'password';
      if (touched[otherField]) {
        const otherError = validateField(otherField, formData[otherField]);
        setErrors(prev => ({ ...prev, [otherField]: otherError }));
      }
    }
  };

  const handleEntityTypeChange = (e) => {
    const selectedEntityType = e.target.value;
    setEntityType(selectedEntityType);
    
    // Map entity type to userType
    const mappedUserType = selectedEntityType === 'Loan Processing Lender' ? 'Loan Processing Lender' : 'DSA';
    setFormData(prev => ({ ...prev, userType: mappedUserType }));
    setTouched(prev => ({ ...prev, userType: true }));
    
    // Validate the userType field
    const error = validateField('userType', mappedUserType);
    setErrors(prev => ({ ...prev, userType: error }));
  };

  const validateStep = (step) => {
    let isValid = true;
    const newErrors = { ...errors };
    if (step === 1) {
      const fields = ['lenderName', 'email', 'phoneNumber'];
      fields.forEach(field => {
        const error = validateField(field, formData[field]);
        if (error) {
          newErrors[field] = error;
          isValid = false;
        }
      });
    } else if (step === 2) {
      const fields = ['gstNumber', 'panNumber', 'userType'];
      fields.forEach(field => {
        const error = validateField(field, formData[field]);
        if (error) {
          newErrors[field] = error;
          isValid = false;
        }
      });
    } else if (step === 3) {
      const fields = ['username', 'password', 'confirmPassword'];
      fields.forEach(field => {
        const error = validateField(field, formData[field]);
        if (error) {
          newErrors[field] = error;
          isValid = false;
        }
      });
    }
    setErrors(newErrors);
    return isValid;
  };

  const handleNext = () => {
    if (validateStep(currentStep)) {
      setCurrentStep(prev => prev + 1);
    }
  };

  const handlePrevious = () => {
    setCurrentStep(prev => prev - 1);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateStep(currentStep)) {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/api/auth/registerMasterLender`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            lenderName: formData.lenderName,
            email: formData.email,
            phoneNumber: formData.phoneNumber,
            gstNumber: formData.gstNumber,
            panNumber: formData.panNumber,
            username: formData.username,
            password: formData.password,
            userType: formData.userType
          }),
        });
        const data = await response.text();
        if (!response.ok) {
          throw new Error(data.error || 'Registration failed');
        }
        setModalMessage('Registration successful!');
        setIsModalOpen(true);
        console.log('Registration successful:', data);
      } catch (error) {
        console.error('Error during registration:', error);
        setModalMessage(error.message || 'Error during registration');
        setIsModalOpen(true);
      } finally {
        setRegFetch(1);
        setFormData({
          lenderName: '',
          email: '',
          phoneNumber: '',
          gstNumber: '',
          panNumber: '',
          username: '',
          password: '',
          confirmPassword: '',
          userType: 'DSA'
        });
      }
    }
  };

  return (
    <div
      className="col-md-6"
      style={{
        padding: "20px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        className="card mt-5"
        style={{
          border: "none",
          boxShadow: "0px 0px 10px rgba(0,0,0,0.1)",
          width: "350px",
          height: "70vh",
        }}
      >
        <div className="card-body">
          <h2 className="text-center mb-4" style={{ color: "#ee373b" }}>
            Registration
          </h2>
          <form
            className="d-flex flex-column justify-content-between w-100"
            style={{ height: "80%" }}
            onSubmit={handleSubmit}
          >
            <div className="w-100 h-100">
              {currentStep === 1 && (
                <>
                  <div className="form-group">
                    <label>Lender Name</label>
                    <input
                      type="text"
                      className={`form-control ${
                        touched.lenderName && errors.lenderName ? "is-invalid" : ""
                      }`}
                      name="lenderName"
                      value={formData.lenderName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {touched.lenderName && errors.lenderName && (
                      <div className="invalid-feedback">
                        {errors.lenderName}
                      </div>
                    )}
                  </div>
                  <div className="form-group">
                    <label>Email</label>
                    <input
                      type="email"
                      className={`form-control ${
                        touched.email && errors.email ? "is-invalid" : ""
                      }`}
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {touched.email && errors.email && (
                      <div className="invalid-feedback">{errors.email}</div>
                    )}
                  </div>
                  <div className="form-group">
                    <label>Phone Number</label>
                    <input
                      type="text"
                      className={`form-control ${
                        touched.phoneNumber && errors.phoneNumber ? "is-invalid" : ""
                      }`}
                      name="phoneNumber"
                      value={formData.phoneNumber}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {touched.phoneNumber && errors.phoneNumber && (
                      <div className="invalid-feedback">
                        {errors.phoneNumber}
                      </div>
                    )}
                  </div>
                </>
              )}
              {currentStep === 2 && (
                <>
                  <div className="form-group">
                    <label>Entity Type</label>
                    <select
                      className={`form-control ${
                        touched.userType && errors.userType ? "is-invalid" : ""
                      }`}
                      value={entityType}
                      onChange={handleEntityTypeChange}
                      onBlur={(e) => {
                        setTouched(prev => ({ ...prev, userType: true }));
                      }}
                    >
                      <option value="DSA">DSA</option>
                      <option value="Loan Processing Lender">Loan Processing Lender</option>
                    </select>
                    {touched.userType && errors.userType && (
                      <div className="invalid-feedback">{errors.userType}</div>
                    )}
                  </div>
                  <div className="form-group">
                    <label>GST Number</label>
                    <input
                      type="text"
                      className={`form-control ${
                        touched.gstNumber && errors.gstNumber ? "is-invalid" : ""
                      }`}
                      name="gstNumber"
                      value={formData.gstNumber}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {touched.gstNumber && errors.gstNumber && (
                      <div className="invalid-feedback">{errors.gstNumber}</div>
                    )}
                  </div>
                  <div className="form-group">
                    <label>PAN Number</label>
                    <input
                      type="text"
                      className={`form-control ${
                        touched.panNumber && errors.panNumber ? "is-invalid" : ""
                      }`}
                      name="panNumber"
                      value={formData.panNumber}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {touched.panNumber && errors.panNumber && (
                      <div className="invalid-feedback">{errors.panNumber}</div>
                    )}
                  </div>
                  {/* <div className="form-group">
                    <label
                      style={{
                        fontWeight: "bold",
                        display: "block",
                        marginBottom: "0.5rem",
                      }}
                    >
                      Share Contact Details
                    </label>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "1rem",
                      }}
                    >
                      <label
                        style={{
                          position: "relative",
                          display: "inline-block",
                          width: "50px",
                          height: "24px",
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={formData.userType === "Lender"}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              userType: e.target.checked ? "Lender" : "Private Lender",
                            }))
                          }
                          style={{ opacity: 0, width: 0, height: 0 }}
                        />
                        <span
                          style={{
                            position: "absolute",
                            cursor: "pointer",
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            backgroundColor:
                              formData.userType === "Lender" ? "#ee373b" : "#ccc",
                            transition: "0.2s",
                            borderRadius: "24px",
                          }}
                        ></span>
                        <span
                          style={{
                            position: "absolute",
                            content: '""',
                            height: "18px",
                            width: "18px",
                            left:
                              formData.userType === "Lender" ? "26px" : "4px",
                            bottom: "3px",
                            backgroundColor: "white",
                            transition: "0.2s",
                            borderRadius: "50%",
                          }}
                        ></span>
                      </label>
                      <span style={{ fontSize: "0.9rem" }}>
                        {formData.userType === "Lender" ? "Yes" : "No"}
                      </span>
                    </div>
                  </div> */}
                </>
              )}
              {currentStep === 3 && (
                <>
                  <div className="form-group">
                    <label>Username</label>
                    <input
                      type="text"
                      className={`form-control ${
                        touched.username && errors.username ? "is-invalid" : ""
                      }`}
                      name="username"
                      value={formData.username}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {touched.username && errors.username && (
                      <div className="invalid-feedback">{errors.username}</div>
                    )}
                  </div>
                  <div className="form-group">
                    <label>Password</label>
                    <input
                      type="password"
                      className={`form-control ${
                        touched.password && errors.password ? "is-invalid" : ""
                      }`}
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {touched.password && errors.password && (
                      <div className="invalid-feedback">{errors.password}</div>
                    )}
                  </div>
                  <div className="form-group">
                    <label>Confirm Password</label>
                    <input
                      type="password"
                      className={`form-control ${
                        touched.confirmPassword && errors.confirmPassword ? "is-invalid" : ""
                      }`}
                      name="confirmPassword"
                      value={formData.confirmPassword}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {touched.confirmPassword && errors.confirmPassword && (
                      <div className="invalid-feedback">
                        {errors.confirmPassword}
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>
            <div className="d-flex justify-content-between mt-4 w-100">
              {currentStep > 1 && (
                <button
                  type="button"
                  className="btn"
                  style={{ backgroundColor: "#ee373b", color: "white" }}
                  onClick={handlePrevious}
                >
                  Previous
                </button>
              )}
              {currentStep < 3 ? (
                <button
                  type="button"
                  className="btn ml-auto"
                  style={{ backgroundColor: "#ee373b", color: "white" }}
                  onClick={handleNext}
                >
                  Next
                </button>
              ) : (
                <button
                  type="submit"
                  className="btn ml-auto"
                  style={{ backgroundColor: "#ee373b", color: "white" }}
                >
                  Submit
                </button>
              )}
            </div>
          </form>
        </div>
      </div>
      <InformationModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        message={modalMessage}
      />
    </div>
  );
};

const App = () => {
  const nav = useNavigate();
  const [view, setView] = useState('login');
  const [ regFetch, setRegFetch ] = useState(0);
  return (
    <div style={{ backgroundColor: 'white', minHeight: '100vh' }}>
      <div className='d-flex justify-content-center' style={{height:"100vh",padding:"10px"}}>
        <div className="row justify-content-center w-100">
          <div><button className='btn btn-outline-danger' onClick={()=>{
            nav("/")
          }}>Back</button></div>
          <div className="d-none d-md-flex align-items-center">
            <Login regFetch={regFetch} />
            <div style={{width:"3px", background:"linear-gradient(to bottom, transparent 0%, #ee373b 10%, #ee373b 90%, transparent 100%)", borderRadius: "10px", height:"80vh"}}>.</div>
            <MultiStepRegistrationForm setRegFetch={setRegFetch} />
          </div>
          <div className="d-md-none">
            {view === 'login' ? <Login /> : <MultiStepRegistrationForm />}
            <div style={{ position: 'fixed', bottom: '20px', right: '20px' }}>
              <button onClick={() => setView(view === 'login' ? 'register' : 'login')} className="btn" style={{ backgroundColor: '#ee373b', color: 'white' }}>
                {view === 'login' ? 'New user? Register' : 'or have an account? Login'}
              </button>
            </div>
          </div>
        </div>
      </div>
      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; }
            to { opacity: 1; }
          }
          .card {
            animation: fadeIn 0.5s ease-in-out;
          }
          @media (max-width: 768px) {
            .col-md-6 {
              width: 100%;
            }
          }
        `}
      </style>
    </div>
  );
};

export default App;